import * as React from "react"
import type { SVGProps } from "react"
const SvgTextStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.24 19.45a5.4 5.4 0 0 0 2.91.84q2.07 0 3.64-1.27a4 4 0 0 0 1.56-3.23v-.3q0-.5-.36-.85a1.2 1.2 0 0 0-.87-.35q-.5 0-.85.35t-.34.85q0 1.05-.82 1.72a3 3 0 0 1-1.91.68q-.87 0-1.64-.45-.75-.45-1.21-1.2a1.4 1.4 0 0 0-.76-.62 1.1 1.1 0 0 0-.94.1 1.2 1.2 0 0 0-.59.65 1 1 0 0 0 .06.84 6 6 0 0 0 2.12 2.24M2.29 12q.29.29.71.29h18q.42 0 .71-.3a1 1 0 0 0 .29-.7 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28H9.73a3 3 0 0 1-.26-1.25c0-.51.14-.94.38-1.38a2 2 0 0 1 .95-.85 3.2 3.2 0 0 1 2.37-.07q.5.2.88.62.34.4.84.48t.91-.23q.37-.27.47-.72a1 1 0 0 0-.17-.8 5 5 0 0 0-1.79-1.45 5 5 0 0 0-2.26-.5q-1.35 0-2.53.6T7.72 6.5a5.6 5.6 0 0 0-.53 3.78H3a1 1 0 0 0-.71.28 1 1 0 0 0-.29.72q0 .42.29.7" />
  </svg>
)
export default SvgTextStrikethrough
